module.exports = __webpack_public_path__ + "img/UsuarioSinUso.0239626e.svg";